import { render, staticRenderFns } from "./compare_drivers_history.vue?vue&type=template&id=52116567&"
import script from "./compare_drivers_history.vue?vue&type=script&lang=js&"
export * from "./compare_drivers_history.vue?vue&type=script&lang=js&"
import style0 from "./compare_drivers_history.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports